// extracted by mini-css-extract-plugin
module.exports = {"curtain":"LoadOverlay_curtain__s7TIc","ldsFacebook":"LoadOverlay_ldsFacebook__3qDVO","lds-facebook":"LoadOverlay_lds-facebook__1bapK"};